// extracted by mini-css-extract-plugin
export default {"shippingInfoContainer":"_57655f17","shipsFrom":"_6d9941cb","hoverable":"_bdbcc7c0","tooltipWrapper":"_5b69d3ca","shippingModalLink":"_1a605955","displayInline":"_748c95f"};